import { Component, OnInit, Input } from '@angular/core';
import { BuscarCasos } from 'src/app/model/pld/buscarcaso.model';
import { DetalleCaso, ModelCaso, ModelAtendenderCaso } from 'src/app/model/pld/detallecaso.model';
import { CatalogosService } from 'src/services/catalogos/catalogos.service';
import { AppComponent } from 'src/app/app.component';
import { AlertasService } from 'src/services/pld/alertas.service';
import { SweetServices } from 'src/services/sweet.services';
import { ComunicacionService } from 'src/services/comunicacion.service';
import { Router} from '@angular/router';
import { NgForm } from '@angular/forms';
import { ExcelService } from 'src/services/persona/excel.service';
import Swal from 'sweetalert2';
import { environment } from 'src/environments/environment';
import { SessionSotrageService } from 'src/services/session-sotrage.service';

import { TableColumn } from '@spot-utils/dynamic-table';
import { AppConstants } from 'src/app/common/enum/app.constants';
import { EnumTipoConsultaOptimizado } from 'src/app/common/enum/TipoPersona.enum';
import { StreamDownloadFetch } from 'src/app/common/Helper/StreamHelper';
import { createWriteStream } from 'streamsaver';

declare var $;

@Component({
	selector: 'app-buscar-caso',
	templateUrl: './buscar-caso.component.html',
	styleUrls: ['./buscar-caso.component.css'],
})

export class BuscarCasoComponent implements OnInit {
	public traduccion = environment.traduccion;
	tipoPersona: number;
	esOpen = false;
	// tslint:disable-next-line: no-input-rename
	@Input('tipocaso') tipocaso: number;

	casos: BuscarCasos;
	detalle: DetalleCaso;
	total: number;
	casosResultados: any[];
	reporteResultados: any[];
	totalRegistros: number;
	numPage: number;
	contador: number;
	RolIdAtiendeCasosArray: string[];
	resultadoPaginadoTotal: [];
	rolAtiendeCasosId: number;
	EsRolAdminAtender: boolean;
	arrayCasosId: any[];
	alertas: any[] = [];
	actividadesVulnerables: any[] = [];
	actividadVulnerableId: number = 0;

	fromSearchButtom: boolean = false;
  // Variables para componentes de tabla Inicio
  data: any[] = [];
  columns: TableColumn[] = [];
  totalrows: number = 0;
  pageSize: number = 15;
  loadingTotalRows: boolean = false;
  
  // Variables para componentes de tabla Cierre

  //Stream Download Inicio
  private abortCtrl?: AbortController;

	constructor(
		private catalogoService: CatalogosService,
		private main: AppComponent,
		public alertaService: AlertasService,
		private alerta: SweetServices,
		private excelService: ExcelService,
		private comunicacion: ComunicacionService,
		private router: Router,
		private ssstorage: SessionSotrageService,
    	private sHelper: StreamDownloadFetch
	) {
		this.casos = new BuscarCasos();
		this.actividadVulnerableId = this.ssstorage.getActividadVulnerable();
		this.alertas = this.catalogoService.getAlerta().filter((h) => h.actividadVulnerableId   == this.actividadVulnerableId);

		this.actividadesVulnerables = this.catalogoService.getActividades();
		this.casosResultados = [];
		this.total = 0;
		this.totalRegistros = 0;
		this.numPage = 0;
		this.contador = 1;
		this.arrayCasosId = [];
	}

	getTooltipTexto(alertaId: number): string {
		const alertaSeleccionada = this.alertas.find(a => a.alertaId === alertaId);
		if (!alertaSeleccionada){
			return 'Selecciona una opción';
		} 

		const actividad = this.actividadesVulnerables.find(av => av.id === alertaSeleccionada.alertaAVId);
		return actividad ? actividad.descripcion : '';
	}

	generarReporteAsync = () => {
		this.reporteResultados = [];
		let promise = new Promise((resolve, reject) => {
			this.main.loading = true;
			this.alertaService.imprimirCasos(this.casos).subscribe((response) => {
				if (response.isCorrect && response.data.info != null) {
					response.data.info.result.forEach((element) => {
						delete element.listaNegraTipo;
						delete element.coincidencia;
						delete element.lstDetalle;
						// tslint:disable-next-line: max-line-length
						var json = JSON.stringify(element)
							.replace('caso', 'Número de Caso')
							.replace('personaId', 'Número de Persona')
							.replace('tipoPersona', 'Personalidad Fiscal')
							.replace('persona', 'Nombre')
							.replace('dictaminado', 'Dictaminado')
							.replace('reportado', 'Reportado')
							.replace('comentario', 'Comentarios')
							.replace('rfc', 'RFC')
							.replace('referencia', 'Referencia de la Transacción')
							.replace('tMonto', 'Monto de la Transacción')
							.replace('divisa', 'Divisa')
							.replace('tFechaPago', 'Fecha de Operación')
							.replace('instrumento', 'Instrumento')
							.replace('lstDetalle', '')
							.replace('contrato', 'Contrato')
							.replace('alerta', 'Alerta')
							.replace('fechaDeteccion', 'Fecha de Detección')
							.replace('montoCaso', 'Monto del Caso')
							.replace('coincidencia', 'Coincidencia')
							.replace('listaNegraTipo', 'Lista Negra Tipo')
							.replace('motivo', 'Motivo de Reporte')
						var jsonReporte = JSON.parse(json);
						this.reporteResultados.push(jsonReporte);
					});

					this.main.loading = false;
					this.alerta.AlertaSuccessTimer('El Reporte General se ha generado con éxito.');
					this.excelService.exportAsExcelFile(
						this.reporteResultados, this.nameReport(), this.nameReport()
					);
					resolve(response);
				} else {
					this.main.loading = false;
					this.alerta.AlertaInfo(response.message);
				}
			});
		});
		return promise;
	};

	ngOnInit() {
		this.casos.Comite = this.tipocaso;
		this.tipoPersona = 2;

		let rolUsuarioActual = this.ssstorage.getCurrentSession().rolId.toString();
		this.RolIdAtiendeCasosArray = this.alertaService
			.obtenerRolIdAtiendeCasos()
			.split(',')
			.map((item) => item.trim());
		this.EsRolAdminAtender = this.RolIdAtiendeCasosArray.indexOf(rolUsuarioActual) != -1;
	}

	validarFormulario(formBuscarCasos: NgForm) {
		let date = new Date(this.casos.FechaInicial);
		const parsedDateInicial = Date.parse(date.toDateString());
		date = new Date(this.casos.FechaFinal);
		const parsedDateFinal = Date.parse(date.toDateString());
		let error: boolean;
		error = false;

		if (isNaN(parsedDateInicial)) {
			this.alerta.AlertaError('Fecha Inicial no válida.');

			error = true;
		}
		if (isNaN(parsedDateFinal)) {
			this.alerta.AlertaError('Fecha Final no válida.');

			error = true;
		}

		if (error) {
			return;
		}
		if (formBuscarCasos.valid) {
			this.main.loading = true;
			//this.casos.Pagina = 1;
			this.casos.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
			this.bucarCasos();
			setTimeout(() => {
				this.bucarTotalesCasosOptimizado();
			}, 2000);
		}
	}

	bucarCasos() {
		this.fromSearchButtom = false;
		this.casosResultados = [];
		this.total = 0;
		this.totalRegistros = 0;
		this.casos.Dictaminado = +this.casos.Dictaminado;
		this.casos.Reportado = +this.casos.Reportado;
		this.casos.NoCaso = this.casos.NoCaso;
		this.casosResultados = [];
		this.casos.AlertaId = +this.casos.AlertaId;
		this.main.loading = true;
		this.casos.TipoConsulta = EnumTipoConsultaOptimizado.getDataGrid;
		setTimeout(() => {
			this.alertaService.buscarCasos(this.casos).subscribe(
				(response) => {
					var resp = response;
					this.main.loading = false;
					if (response == null) {
						this.alerta.AlertaError(
							'Existe un error, si persiste contacte al administrador del Sitio.'
						);
					} else if (response.isCorrect === 'false') {
						this.casos.Pagina > 1 ? this.casos.Pagina-- : (this.casos.Pagina = 1);
						this.alerta.AlertaError(response.message);
					} else if (response.data.total === 0) {
						this.data = [];
						this.columns = [];
						this.alerta.AlertaSinResultados(response.message);
						this.casos.Pagina > 1 ? this.casos.Pagina-- : (this.casos.Pagina = 1);
					} else {
						this.data = response.data.info.result.data;
						this.columns = (response.data.info.result.columns || []).filter((col: any) => col.field !== 'colorEstatus');
						this.total = response.data.total;
						this.casosResultados = response.data.info.result;
						this.totalRegistros = response.totalRegistros;
						this.numPage = Math.ceil(this.totalRegistros / 15);
					}
				},
				(err) => {
					this.main.loading = false;
					this.data = [];
					this.columns = [];
					if (err.error.message == null) {
						this.alerta.AlertaCatch(err);
					} else {
						this.alerta.AlertaError(err.error.message);
					}
				}
			);
		}, 1500);
	}

  bucarTotalesCasosOptimizado() {
    this.casos.TipoConsulta = EnumTipoConsultaOptimizado.getDataCountRows;
    this.loadingTotalRows = true;
    this.alertaService.buscarCasosConteos(this.casos).subscribe(response => {
      this.loadingTotalRows = false;
      if (response.isCorrect == 'true') {
        var rsp = response.data.info.result;
        this.totalRegistros = response.totalRegistros;
		if(!this.casos.Comite) {this.totalrows = response.totalRegistros} else {this.totalrows = this.total}
		this.fromSearchButtom = true;
      }
    }, (err) => {
      this.loadingTotalRows = false;
      if (err.error.message == null) {
        this.alerta.AlertaCatch(err);
      } else {
        this.alerta.AlertaError(err.error.message);
      }
    });
  }

  //Reportes Inicio
  async validateStreamDownload() {
    if (this.totalRegistros == 0) {
      this.alerta.AlertaSinResultados(`No se encontraron resultados.`);
    } else if (this.totalRegistros > AppConstants.MAX_ROWS_PER_REPORT_VALIDATE) {
      Swal.fire({
        title: "Consulta demasiado grande",
        html: `El límite máximo de la consulta es ${AppConstants.MAX_ROWS_PER_REPORT_VALIDATE / 1000000}
        millones de filas.`,
        reverseButtons: true
      }).then((rsp) => {
        if (rsp.value) {
          console.log("El usuario aceptó");
        }
      });
    } else {
      this.casos.TipoConsulta = EnumTipoConsultaOptimizado.getDataReport;
      await this.streamDownload();
    }
  }

  async streamDownload() {
    this.abortCtrl = new AbortController();
    this.main.loading = true;
    try {
      var fileName = this.casos.Comite ? "CasosComite" : "Casos";
      var numExcel = Math.ceil(this.totalRegistros / AppConstants.MAX_ROWS_PER_EXCEL);
      this.alerta.AlertaSuccessTimer(`Se descargarán ${numExcel} archivos.`);
      let rsp = await this.sHelper.Casos(this.casos, this.abortCtrl.signal);
      if (!rsp.ok) throw new Error("Error en servidor");
	  let blob = await rsp.blob();
	  let url = window.URL.createObjectURL(blob);
	  let doc = document.createElement('a');
	  doc.href = url;
	  doc.download = `${fileName}_${Date.now()}.zip`;
	  document.body.appendChild(doc);
	  doc.click();
	  document.body.removeChild(doc);
	  window.URL.revokeObjectURL(url);
      this.alerta.alertaInfo('Descarga completada');
    } catch (err) {
      this.alerta.AlertaError("Descarga fallida. El navegador limpiará el temporal.");
    } finally {
      this.main.loading = false;
    }
  }

	nameReport() {
		let nameReporteExcel: string;

		if (this.casos.Comite == 2) {
			nameReporteExcel = 'AlertasComite';
		} else if (this.casos.Comite == 1) {
			nameReporteExcel = 'AlertasCumplimiento';
		} else {
			nameReporteExcel = 'Alertas';
		}

		return nameReporteExcel;
	}

	paginador(value) {
		this.main.loading = true;
		if (value) {
			this.casos.Pagina++;
			this.contador++;
			this.bucarCasos();
		}

		if (!value) {
			this.casos.Pagina--;
			this.contador--;
			this.bucarCasos();
		}
	}

	detalleCaso(caso: any) {
		this.main.loading = true;
		this.comunicacion.limpiarStorage(false);
		this.detalle = new DetalleCaso();

		this.detalle.caso.CasoId = caso['casoId'];
		this.detalle.caso.Nombre = caso['nombre'];

		if (caso['sNombre'] != null) {
			this.detalle.caso.Nombre += ' ' + caso['sNombre'];
		}

		if (caso['apellidoPaterno'] != null){
			this.detalle.caso.Nombre += ' ' + caso['apellidoPaterno'];
		} 

		if (caso['apellidoMaterno'] != null){
			this.detalle.caso.Nombre += ' ' + caso['apellidoMaterno'];
		} 

		this.detalle.caso.FechaRegistro = caso['fechaRegistro'];
		this.detalle.caso.AlertaTipo = caso['alerta'];
		this.detalle.caso.Detalle = caso['detalle'];
		this.detalle.caso.Monto = caso['monto'];
		this.detalle.caso.ClaveCia = caso['claveCia'];
		this.detalle.caso.EsCoincidencia = caso['esCoincidencia'];
		this.detalle.caso.PersonaId = caso['personaId'];
		this.detalle.caso.TipoPersona = caso['tipoPersona'];
		this.detalle.caso.MotivoReporte =  caso['motivoReporte'];
		this.detalle.caso.TipoCaso = this.tipocaso;
		this.detalle.caso.Nombre = this.detalle?.caso?.Nombre?.replace(/null/gi, '') || '';
		this.detalle.caso.PuntajeRiesgo = caso['puntajeRiesgo'];
		this.detalle.caso.MotivoReporte = caso['motivoReporte'];

		if (this.casos.Comite == 0) {
			this.comunicacion.setCaso(this.detalle);
			setTimeout(() => {
				this.router.navigate(['/v2/detallealerta'], { queryParams: { comite: 0 } });
			}, 2000);
		} else if (this.casos.Comite == 1) {
			this.comunicacion.setCaso(this.detalle);
			setTimeout(() => {
				this.router.navigate(['/v2/detallealerta'], { queryParams: { comite: 1 } });
			}, 2000);
		} else {
			this.comunicacion.setCaso(this.detalle);
			setTimeout(() => {
				this.router.navigate(['/v2/detallealerta'], { queryParams: { comite: 2 } });
			}, 2000);
		}
	}

	validarDictamen(reportado: number) {
		if (reportado == 1) {
			this.casos.Dictaminado = 1;
		}
	}

	buscarReporte() {
		this.alerta.AlertaSuccessTimer('El Reporte se descargará en breve.');
		this.main.loading = true;
		this.generarReporteAsync()
			.then((response) => {
				this.alerta.AlertaSuccessTimer('El Reporte General se ha descargado con éxito.');
				this.main.loading = false;
			})
			.catch((error) => this.alerta.AlertaError(error));
		this.main.loading = false;
	}

	abrirNuevo() {
		$('#modalCliente').modal('toggle');
		this.alertaService.persona = undefined;
		this.esOpen = true;
	}

	cerrarCaso() {
		$('#modalCliente').modal('toggle');
		this.alertaService.persona = undefined;
		this.esOpen = false;
	}

	cerrarTransacciones() {
		$('#modalTransaccion').modal('toggle');
		$('#modalCliente').modal('toggle');
		this.alertaService.persona = undefined;
		this.esOpen = false;
	}

	cerrarCCaso() {
		this.alertaService.caso = new ModelCaso();
		$('#modalCaso').modal('hide');
		$('#modalTransaccion').modal('show');
		this.alertaService.transaccionesRelacionar = [];
	}

	transacciones() {
		this.esOpen = false;
		$('#modalCliente').modal('toggle');
		$('#modalTransaccion').modal('toggle');
	}

	nuevo() {
		$('#modalTransaccion').modal('toggle');
		$('#modalCaso').modal('toggle');
	}

	validarFormularioCasos(formGuardarCaso) {
		const parsedDateInicial = Date.parse(this.alertaService.caso.FechaRegistro);
		let error: boolean;
		error = false;

		if (isNaN(parsedDateInicial)) {
			this.alerta.AlertaError('Fecha Registro no válida.');

			error = true;
		}

		if (error) {
			return;
		}
		if (formGuardarCaso.valid) {
			this.main.loading = true;
			this.guardarCaso();
		}
	}

	invalidCaso(): boolean {
		if (
			this.alertaService.caso.AlertaId === null || 
			this.alertaService.caso.AlertaId === undefined) {

				return true;
			}

		if (
			!(Number(this.alertaService.caso.AlertaId) === 59 || 
			Number(this.alertaService.caso.AlertaId) === 60)) {
			return (
				this.alertaService.caso.Comentarios === '' ||
				this.alertaService.caso.MotivoReporte === '' ||
				this.alertaService.caso.Comentarios === null ||
				this.alertaService.caso.MotivoReporte === null ||
				this.alertaService.caso.Comentarios === undefined ||
				this.alertaService.caso.MotivoReporte === undefined
			);
		}

		this.alertaService.caso.Comentarios = '';
		this.alertaService.caso.MotivoReporte = '';
		return false;
	}

	guardarCaso() {
		let mcaso = new DetalleCaso();
		mcaso.caso = this.alertaService.caso;
		mcaso.caso.PersonaId = this.alertaService.persona.personaId;
		mcaso.caso.AlertaId = Number(mcaso.caso.AlertaId);
		mcaso.transaccion = this.alertaService.transaccionesRelacionar;
		mcaso.transaccion.forEach((element) => {
			delete element['fechaRegistro'];
		});
		$('#modalCaso').modal('toggle');

		this.alertaService.guardarCaso(mcaso).subscribe(
			(response) => {
				this.main.loading = false;
				this.alertaService.persona = undefined;
				this.alertaService.transaccionesRelacionar = [];
				this.alertaService.caso = new ModelCaso();
				if (response == null) {
					this.alerta.AlertaError(
						'Existe un error, si persiste contacte al administrador del Sitio.'
					);
				} else if (response.isCorrect === 'false') {
					this.alerta.AlertaError(response.message);
				} else {
					this.alerta.AlertaSuccessTimer(response.message);
				}
			},
			(err) => {
				this.main.loading = false;
				this.alerta.AlertaCatch(err);
			}
		);
	}

	registrarAtenderCaso() {
		if (this.EsRolAdminAtender) {
			this.arrayCasosId = this.casosResultados
				.filter(
					(x) =>
						(x.esAtiendeUsuario == false && x.usuarioAtiende != '') ||
						(x.esAtiendeUsuario == true && x.usuarioAtiende == '')
				)
				.map((y) => ({ casoId: y.casoId, esAtiendeUsuario: y.esAtiendeUsuario }));

			if (this.arrayCasosId.length == 0) {
				this.alerta.AlertaTituloInfo('Validación', 'No hay cambios que aplicar');
				return;
			}
		}

		if (!this.EsRolAdminAtender) {
			// Se mantiene en una línea para no afectar la búsqueda
			this.arrayCasosId = this.casosResultados.filter((x) => x.esAtiendeUsuario == true && x.usuarioAtiende == '').map((y) => ({ casoId: y.casoId, esAtiendeUsuario: y.esAtiendeUsuario }));

			if (this.arrayCasosId.length == 0) {
				this.alerta.AlertaTituloInfo(
					'Validación', 'Debes seleccionar al menos un caso para asignártelo'
				);
				return;
			}
		}
		let Asigandos = this.arrayCasosId.filter((x) => x.esAtiendeUsuario == true).length;
		let desAsigandos = this.arrayCasosId.filter((x) => x.esAtiendeUsuario == false).length;

		let textoAux: String;

		if (this.EsRolAdminAtender) {
			if (Asigandos > 0 && desAsigandos > 0) {
				textoAux = 'Está por Asignar/Desasignar los casos modificados';
			}
			else if (Asigandos > 0){
				textoAux = 'Está por Asignar los casos modificados';
			}
			else if (desAsigandos > 0){
				textoAux = 'Está por Desasignar los casos modificados';
			}
		} else {
			textoAux = 'Está por Asignarse los casos seleccionados';
		}

		const swalWithBootstrapButtons = Swal.mixin({
			customClass: {
				confirmButton: 'btn btn-success',
				cancelButton: 'btn btn-danger',
			},
			buttonsStyling: false,
		});

		swalWithBootstrapButtons
			.fire({
				title: textoAux,
				text: '¿Deseas continuar?',
				type: 'warning',
				showCancelButton: true,
				confirmButtonText: 'Sí',
				cancelButtonText: 'No',
				reverseButtons: true,
			})
			.then((result) => {
				if (result.value) {
					let modelAtender = new ModelAtendenderCaso();
					modelAtender.CasoArray = this.arrayCasosId;
					modelAtender.UsuarioId = this.ssstorage.getCurrentUser().usuarioId;
					modelAtender.EsRolAdminAtender = this.EsRolAdminAtender;

					this.main.loading = true;
					this.alertaService.AsignarAtenderCaso(modelAtender).subscribe(
						(response) => {
							this.main.loading = false;
							if (response == null) {
								this.alerta.AlertaError(
									'Existe un error, si persiste contacte al administrador del Sitio.'
								);
							} else if (response.isCorrect === 'false') {
								this.alerta.AlertaError(response.message);
							} else if (response.data.total === 0) {
								this.alerta.AlertaSinResultados(response.message);
							} else {
								this.alerta.AlertaSinResultados(response.message);
								setTimeout(() => {
									this.bucarCasos();
								}, 1500);
							}
						},
						(err) => {
							this.main.loading = false;
							if (err.error.message == null) this.alerta.AlertaCatch(err);
							else this.alerta.AlertaError(err.error.message);
						}
					);
				// TODO: Validar en el futuro qué aplica en esta validación
				} else if (result.dismiss === Swal.DismissReason.cancel) {
				}
			});
	}

	onTableAction(e: { action: string; row: any }) {
		if (e.action === 'detail') {
		this.detalleCaso(e.row)
		}
	}


	onNewBatch(event: { batchNumber: number, page: number }) {
		this.casos.BatchNumber = event.batchNumber;
		this.casos.Pagina = event.page;
		this.bucarCasos();

	}

	onPrintReport() {
		this.validateStreamDownload();
	}
	
}
